import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compose Tailwind class names.
 *
 * Ported from the legacy helper at
 * artifacts/high-performer-os/src/lib/utils.ts, which every shared primitive
 * depends on. `clsx` flattens conditionals and arrays; `twMerge` then resolves
 * conflicts so a caller-supplied class wins over a primitive's default rather
 * than both landing in the class list and the outcome depending on CSS order.
 *
 * Only the `cn` helper is ported here. The legacy module also exports
 * `computePrioritySignals`, which is report-scoring logic, not a visual
 * concern, and is out of scope for the visual system.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
